var cilTextSquare = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M16,496H496V16H16ZM48,48H464V464H48Z' class='ci-primary'/><polygon fill='var(--ci-primary-color, currentColor)' points='112 176 144 176 144 144 224 144 224 368 192 368 192 400 320 400 320 368 288 368 288 144 368 144 368 176 400 176 400 112 112 112 112 176' class='ci-primary'/>"];

export { cilTextSquare };

